import styled from 'styled-components';

export const GameStoryThumbnailWrapper = styled.div`
    width: var(--gameday-gamestory-height);
    height: var(--gameday-video-carousel-height);
`;
